/**
 * Shared arming state for the `g → section` two-key navigation chord, kept in a
 * module singleton so the two independent global keydown listeners agree on it:
 *
 *  - `useGoToKeys` arms it on `g` and consumes it on the second key.
 *  - the `PageShortcutsProvider` dispatcher skips while it is armed, so a chord's
 *    second key (e.g. the `c` of `g c`) is never ALSO handled as a page-scoped
 *    shortcut regardless of which listener fires first.
 */
export const GOTO_WINDOW_MS = 1200;

let armedAt: number | null = null;

/** Start (or restart) the ~1.2s window after `g` is pressed. */
export const armGoTo = (): void => {
  armedAt = Date.now();
};

/** Clear the armed window (the chord completed, expired, or was cancelled). */
export const consumeGoTo = (): void => {
  armedAt = null;
};

/** True while a `g` chord is pending and still inside its window. */
export const isGoToArmed = (): boolean =>
  armedAt !== null && Date.now() - armedAt <= GOTO_WINDOW_MS;
